import React from 'react';
import { useAuthState } from '../../../../context/auth';
import { useTheme, Text, Pressable } from 'native-base';
const CommunicationPreferencesButton = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const authState = useAuthState();
  return /*#__PURE__*/React.createElement(Pressable, {
    bg: colors.purple.primary,
    borderRadius: "50px",
    width: "300px",
    onPress: () => props.toggleProfileModal({
      publicProfileUserId: authState.platform_user_id,
      openCommunicationPreferencesModal: true
    })
  }, /*#__PURE__*/React.createElement(Text, {
    alignSelf: "center",
    color: colors.white
  }, "Open Communication Preferences"));
};
export default CommunicationPreferencesButton;
//# sourceMappingURL=CommunicationPreferencesButton.js.map